// Bridge to the PhoneHQ desktop shell (ch3-frontend/ch3-desktop). In a regular browser
// window.phqDesktop is undefined and these fall back to the web behaviour.

// window.focus() can't raise a hidden or minimized desktop window, so notification
// clicks ask the shell to show it.
export const focusAppWindow = (): void => {
    if (window.phqDesktop) {
        window.phqDesktop.focusWindow();
    } else {
        window.focus();
    }
};

export const setAppBadge = (count: number): void => {
    window.phqDesktop?.setBadgeCount(count);
};
